module.exports = __webpack_public_path__ + "img/youpaq-logo.1a54d5df.svg";